// Func = limiting Scope for this file
var lastScrollTop = 0;
document.addEventListener("DOMContentLoaded", DOMReady);
(function(){

	$(document).ready(function () { 

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
// Dom Ready Funtion
function DOMReady() {

    "use strict";

	// ------- Hovered Items Navs -------
	let itemMenu = document.querySelectorAll('.privary-navigation__item a');
	let itemMenuThrid = document.querySelectorAll('.tertiary-navigation__item a');
	let itemMenuHero = document.querySelectorAll('.uvp li a');

	function addClassHovered(arrayItems){
		arrayItems.forEach(function (i) {
			(i).addEventListener("mouseover", function( event ) { 
				i.parentNode.parentElement.classList.add('s-hovered')
			}, false);
			(i).addEventListener("mouseout", function( event ) {   
				i.parentNode.parentElement.classList.remove('s-hovered')
			  }, false);
		});
	};

	addClassHovered(itemMenu);
	addClassHovered(itemMenuHero);
	addClassHovered(itemMenuThrid);
	// ------- end spaces page ----------

	
	// ------- Function wrapper text -------
	const btnHamilton = document.querySelectorAll(".jsBtn");
	btnHamilton.forEach(function (value, key) {

		var jsBtn = value.innerHTML;
		//separe words
		jsBtn = jsBtn.split(" ");

		//get last words
		var lastWord = jsBtn[jsBtn.length - 1];

		//separe letters
		lastWord = lastWord.split("");
		var newLastWord = "";

		//concat all letters and add span with class "white-on-hover" before last 6 letters
		for (let i = 0; i < lastWord.length; i++) {
			if (i == lastWord.length - 4) {
				newLastWord += '<span class="white-on-hover">';
				newLastWord += lastWord[i];
			} else if (i == lastWord.length - 1) {
				newLastWord += lastWord[i];
				newLastWord += "</span>";
			} else {
				newLastWord += lastWord[i];
			}
		}

		//concat all words adding the new last word
		var newjsBtn = "";
		for (let i = 0; i < jsBtn.length; i++) {
			if (i != jsBtn.length - 1) {
				newjsBtn += jsBtn[i];
				newjsBtn += " ";
			} else {
				newjsBtn += newLastWord;
			}
		}

		//change the text for new text
		value.innerHTML = newjsBtn;

	})
	// ------- End Function wrapper text -------

	// ------- email signup animation  -------
	if(document.getElementById('email-signup_email_address') || document.getElementById('email-signup_email_address')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

		//Form Contact animation 
		function attachEvents(elementList, eventName, handlerFunction) {
			if(typeof elementList == "string")
					elementList = document.querySelectorAll(elementList);
			for(var i = 0; i < elementList.length; i++)
					elementList[i].addEventListener(eventName, handlerFunction);
		}
		attachEvents(".form-module-wrapper input", "click", function(event) {
				this.parentElement.classList.add('moved');
		});
		attachEvents(".form-module-wrapper textarea", "click", function(event) {
				this.parentElement.classList.add('moved');
		});
	}
	// ------- End email signup animation -------

	// ------- Amenities Toggle  ------- 
	if(document.getElementsByClassName('itemsColumns').length > 0){
		// Add title section
		let wrappColumns = document.querySelector(".itemsColumns");
		const h2Title = document.createElement("p");
		h2Title.textContent = "Our Team";
		h2Title.className += "titleToogle"
		wrappColumns.insertAdjacentElement("afterbegin", h2Title);
	}

	if(document.getElementsByClassName('itemsToogle').length > 0){

		let allAccordionItems = document.getElementsByClassName('js-toggle');

		// Add title section
		let wrappAccordion = document.querySelector(".itemsToogle");
		const h2Title = document.createElement("p");
		h2Title.textContent = "Our Team";
		h2Title.className += "titleToogle"
		wrappAccordion.insertAdjacentElement("afterbegin", h2Title);
		// End Add title section

		function accordionItems(arrayItems){
			let allALength = arrayItems.length;
			for(let i =0; i < allALength; i++){
				arrayItems[i].addEventListener('click', function(){
					let currentParent = this.parentElement;
					let currentCopyHeight = currentParent.children[0].nextElementSibling.children[0].clientHeight;
					let currentCopy = currentParent.children[0].nextElementSibling;
					if(currentParent.classList.contains('open')){
						currentParent.classList.remove('open');
						currentCopy.style.height = '0';
					} else {
						currentParent.classList.add('open');
						currentCopy.style.height = currentCopyHeight + 'px';
					}
				});
			};
		};

		setTimeout(() => {
			accordionItems(allAccordionItems);
		}, 1000);
	}
	// ------- End Amenities Toggle -------
	
	// ------- Remove Required Input type checkbox Form Footer  -------
	document.forms[0].querySelector('input[name="subscribe"]').classList.remove('required')
	// ------- End Remove Required Input type checkbox Form Footer -------
	
	// ------- Remove href tags to no link -------
		let noHref = document.querySelectorAll('a[aria-label="Overview page of "]');
		for (let i = 0; i < noHref.length; i++) { noHref[i].removeAttribute("href") }
	// ------- End Remove href tags to no link -------
	
	// ------- Init  Lenis Scroll  -------
	const lenis = new Lenis()

	lenis.on('scroll', (e) => {
	//   console.log(e)
	})
	
	function raf(time) {
	  lenis.raf(time)
	  requestAnimationFrame(raf)
	}
	
	requestAnimationFrame(raf)
	// ------- End Init  Lenis Scroll -------
	
	// ------- tablet / mobile menu cta -------
	if(document.getElementById('menu-sm-cta-js')){
		let menuMobile = document.getElementById('main-menu');
		document.getElementById('menu-sm-cta-js').addEventListener('click', function(e){
			e.preventDefault();
			if(menuMobile.classList.contains('open')){
				document.getElementById('main-menu').classList.remove('open')
				this.classList.remove('open')
				document.getElementById('menutext-js').innerHTML = 'Menu';
				document.querySelector("body").classList.remove('noScroll');
				if(lastScrollTop < 80){
					document.getElementById('header').classList.remove('open-menu');
				}
			} else {
				document.getElementById('main-menu').classList.add('open');
				this.classList.add('open');
				document.getElementById('menutext-js').innerHTML = 'Close';
				document.getElementById('header').classList.add('open-menu');
				document.querySelector("body").classList.add('noScroll')
			}
		});
	}
	// ------- End tablet / mobile menu cta -------
	
	// ------- change id Navs -------
	if(document.querySelector('.main-menu #primary-nav')){
		document.querySelector('.main-menu #primary-nav').id = 'primary-nav_sm';
		document.querySelector('.main-menu #privary-navigation').id = 'privary-navigation_sm';
	}
	if(document.querySelector('.main-menu #third-nav')){
		document.querySelector('.main-menu #third-nav').id = 'third-nav_sm';
		document.querySelector('.main-menu #tertiary-navigation').id = 'tertiary-navigation_sm';
	}
	// ------- End change id Nav -------

	// ------- dropdown for mobile -------
	 document.querySelectorAll('.main-menu #privary-navigation_sm a').forEach(link => {
		link.addEventListener('click', e => {
			if (link.nextSibling.nextSibling != null) {
				document.querySelectorAll('.main-menu #privary-navigation_sm a').forEach(item => {
					if (link.parentNode !== item) item.classList.remove('js-submenu-show');
				});
				//remove this comment if you want show subnav for mobile
				e.preventDefault();
				link.parentNode.classList.toggle('js-submenu-show');
			}
		});
	});

	//add class for icon dropdown 
    document.querySelectorAll('.main-menu #privary-navigation_sm .submenu').forEach(link => {
		let menu = link.parentNode;
		menu.classList.add('ico-dropdown');
	});
	// ------- End dropdown for mobile  -------
	
}